import React from "react";
import { formatDateTime } from "../utils";

const DriverEventsCard = ({ events }) => {
  const list = Array.isArray(events) ? events : [];

  return (
    <div className="logs-driver-events-card">
      <div className="logs-driver-events-card__head">
        <h4>Driver events</h4>
        <span>{list.length} events</span>
      </div>
      {!list.length ? (
        <p className="logs-participant-card__empty">No driver events</p>
      ) : (
        <ul className="logs-driver-events-list">
          {list.map((ev) => (
            <li key={ev._key || ev.id} className="logs-driver-events-item">
              <div className="logs-driver-events-item__dot" />
              <div>
                <strong>{ev.label || ev.eventName}</strong>
                <span>{formatDateTime(ev.createdAt)}</span>
                {ev.lat != null && ev.long != null ? (
                  <small>
                    {ev.lat}, {ev.long}
                  </small>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DriverEventsCard;
